module.exports = __webpack_public_path__ + "static/media/ic-arrow-down.579b0cac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/ic-arrow-down.svg
// module id = 1371
// module chunks = 0